<div class="custom-date-picker-wrapper fw fh">
  @if (timeOption) {

  <div class="calendar-block fw">
    <div class="split from">
      <p-calendar class="unilever-calendar" [(ngModel)]="customDate.from" ngDefaultControl [inline]="true"
        [showTime]="timeOption" [defaultDate]="today" [minDate]="latestMonthStart" [maxDate]="today"
        [yearRange]="yearRange" (onSelect)="customDateChange()" hourFormat="24" appendTo="body"></p-calendar>
    </div>
    <div class="split to" [ngClass]="{'disabled':!customDate.from}">
      <p-calendar class="unilever-calendar" [(ngModel)]="customDate.to" ngDefaultControl [inline]="true"
        [showTime]="timeOption" [disabled]="!customDate.from" [minDate]="customDate.from" [maxDate]="maxDateTo"
        [yearRange]="yearRange" [defaultDate]="today" (onSelect)="customDateChange()" hourFormat="24"
        appendTo="body"></p-calendar>
    </div>
  </div>
  }
  @if (!timeOption) {

  <div class="calendar-block fw">
    <div class="split from">
      <p-calendar class="unilever-calendar" [showTime]="true" [(ngModel)]="customDate.from" ngDefaultControl
        [inline]="true" [defaultDate]="today" [minDate]="latestMonthStart" [maxDate]="today" [yearRange]="yearRange"
        (onSelect)="customDateChange()" hourFormat="24" appendTo="body">
      </p-calendar>
    </div>
    <div class="split to" [ngClass]="{'disabled':!customDate.from}">
      <p-calendar class="unilever-calendar" [(ngModel)]="customDate.to" ngDefaultControl [inline]="true"
        [disabled]="!customDate.from" [showTime]="true" [minDate]="customDate.from" [maxDate]="maxDateTo"
        [yearRange]="yearRange" [defaultDate]="today" (onSelect)="customDateChange()" hourFormat="24"
        appendTo="body"></p-calendar>
    </div>
  </div>
  }
  <div class="button-block">
    <button mat-raised-button class="cancel spc-btn" mat-dialog-close>{{'common.cancel' | translate}}</button>
    <button mat-raised-button class="ok spc-btn" [disabled]="!selectionCorrect" (click)="applyCustomDate()"
      color="primary">{{'common.ok' | translate}}</button>
  </div>
</div>